export default "__VITE_ASSET__483b24ba__"